import { useTranslation } from 'react-i18next';
import { BoundedContent, Button, Column, GridContainer, Link, Row } from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';
import StatText from './StatText';

const StatsSection = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const statistics = [
        {
            id: 'statistic-1',
            text: t('Logomaker GenAi Landing Page > Stats > Stat 1.value'),
        },
        {
            id: 'statistic-2',
            text: t('Logomaker GenAi Landing Page > Stats > Stat 2.value'),
        },
        {
            id: 'statistic-3',
            text: t('Logomaker GenAi Landing Page > Stats > Stat 3.value'),
        },
    ];

    return (
        <BoundedContent
            backgroundColor="warm-white"
            paddingY={{ xs: 4, sm: 4, md: 4, lg: 6 }}
            as="section"
            id="stats"
        >
            <GridContainer dividers>
                <Row
                    as="ul"
                    textAlign="center"
                    marginY={{ xs: 0, sm: 'between-actions' }}
                    marginX={{ xs: 12, sm: 0 }}
                >
                    {statistics.map((stat) => (
                        <Column
                            key={stat.id}
                            as="li"
                            span={4}
                            textAlign="center"
                            style={{ alignContent: 'center' }}
                            paddingY={4}
                        >
                            <StatText text={stat.text} />
                        </Column>
                    ))}
                </Row>
                <Row>
                    <Column span={12} textAlign="center" marginY="between-actions">
                        <Button
                            skin="secondary"
                            textAlign="center"
                            render={(props) => (
                                // TODO: Add tracking
                                <Link
                                    to={logomakerCtaPathByLocale(locale)}
                                    className={props.className}
                                >
                                    {props.children}
                                </Link>
                            )}
                        >
                            {t('Logomaker GenAi Landing Page > Stats > CTA Text.value')}
                        </Button>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default StatsSection;
